module.exports = __webpack_public_path__ + "static/img/2_4_1.cf92384d.jpg";